"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _isNullOrUndefined = _interopRequireDefault(require("../isNullOrUndefined"));
var _accounting = _interopRequireDefault(require("./accounting"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var trLocale = {
  symbol: 'TL',
  // symbol
  decimal: ',',
  thousand: '.',
  precision: 2,
  format: '%v %s' // %s is the symbol and %v is the value
};
var _default = exports.default = {
  format: function format(value, symbolString, precision, removeTrailingZeros) {
    var symbol = symbolString == null ? ' ' : symbolString;
    if ((0, _isNullOrUndefined.default)(value) || !value && isNaN(value)) {
      return '';
    }
    var selectedLocale = _objectSpread({}, trLocale);
    if (symbol) selectedLocale.symbol = symbol === 'YTL' ? 'TL' : symbol;
    if (!(0, _isNullOrUndefined.default)(precision)) selectedLocale.precision = precision;
    selectedLocale.removeTrailingZeros = removeTrailingZeros;
    return _format(value, selectedLocale).trim();
  }
};
function _format(value, options) {
  var currency = {
    symbol: '',
    thousandsSeparator: ',',
    decimalSeparator: '.',
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: false,
    decimalDigits: 2
  };
  var format = {
    pos: '%s%v',
    neg: '-%s%v',
    zero: '%s%v'
  };
  return _accounting.default.formatMoney(value, {
    symbol: (0, _isNullOrUndefined.default)(options.symbol) ? currency.symbol : options.symbol,
    decimal: (0, _isNullOrUndefined.default)(options.decimal) ? currency.decimalSeparator : options.decimal,
    thousand: (0, _isNullOrUndefined.default)(options.thousand) ? currency.thousandsSeparator : options.thousand,
    precision: typeof options.precision === 'number' ? options.precision : currency.decimalDigits,
    format: ['string', 'object'].indexOf((0, _typeof2.default)(options.format)) > -1 ? options.format : format,
    removeTrailingZeros: options.removeTrailingZeros
  });
}